import { createVanIconComponent } from "./van"

const Like = createVanIconComponent("like")
export default Like
